import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  activeStopCommand: 'stop',
  activeLanguage: 'de-AT',
  speechRecognitionLanguages: {
    'de-AT': { id: '0', label: 'de', code: 'de-AT', stopCommand: 'stopp' },
    'en-US': { id: '1', label: 'en', code: 'en-US', stopCommand: 'stop' }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
